<template>
  <div class="profile-input-wrapper">
    <profile-form
      ref="form"
      endpoint="interests"
    >
      <form class="form">
        <fieldset>
          <legend class="sr-only">
            {{ inputTitle }}
          </legend>
          <span class="profile-input-label">{{ listLabel }}</span>
          <div class="flex-grid-1-col gutter-lg">
            <ul class="">
              <li
                v-for="(interest, index) in interestsList"
                :key="index"
                class="profile-input-checkbox"
              >
                <label>
                  <input
                    :id="interest.value"
                    type="checkbox"
                    :value="interest.value"
                    :name="`interest-${index}`"
                    :checked="localProfile.interests.map((item) => item.value)
                      .includes(interest.value)"
                    data-field-type="CheckBoxSet"
                    @input="onInput"
                  >
                  {{ interest.label }}
                </label>
              </li>
            </ul>
          </div>
        </fieldset>
        <input
          type="hidden"
          :value="true"
          name="isActivitiesInterests"
        >
      </form>
    </profile-form>
  </div>
</template>

<script>
  import ProfileInputMixin from '@mixins/profile-input-mixin'

  export default {
    name: 'profile-interests-input',
    mixins: [ProfileInputMixin],
    props: {
      interestsList: {
        type: Array,
        required: true
      },
      listLabel: {
        type: String
      }
    },
    data: () => ({
      localProfile: {
        interests: []
      },
    }),
    methods: {
      onInput(event) {
        console.log(event.target.value)
      }
    }
  }
</script>
